import { ModelRecord } from '@common/models';
import { ISyncModel, SyncModel } from '@common/models/SyncModel';
import { DateTime } from 'luxon';

export interface IClinicUserModel extends ISyncModel {
  clinicUserId: number;
  authUserId: number;
  clinicId: number;
  firstName: string | undefined;
  lastName: string | undefined;
  joinDate: string | undefined;
  clinicRoleName: string | undefined;
  clinicRoleDisplayName: string | undefined;
  clinicRoleAbbreviation: string | undefined;
  isPrimaryInClinicRole: boolean;
  isClinicRole: boolean;
  isVetAssistant: boolean;
  isDVM: boolean;
  anonymizedFirstLastOnly: string | undefined;
}

export class ClinicUserModel
    extends SyncModel
  implements ModelRecord<IClinicUserModel>
{
  clinicUserId: number;
  authUserId: number;
  clinicId: number;
  firstName: string | undefined;
  lastName: string | undefined;
  joinDate: DateTime | undefined;
  clinicRoleName: string | undefined;
  clinicRoleDisplayName: string | undefined;
  clinicRoleAbbreviation: string | undefined;
  isPrimaryInClinicRole: boolean;
  isClinicRole: boolean;
  isVetAssistant: boolean;
  isDVM: boolean;
  anonymizedFirstLastOnly;

  constructor(params: Partial<IClinicUserModel>) {
    super(params);
    this.clinicUserId = _.defaultTo(params.clinicUserId, 0);
    this.authUserId = _.defaultTo(params.authUserId, 0);
    this.clinicId = _.defaultTo(params.clinicId, 0);
    this.firstName = _.defaultTo(params.firstName, '');
    this.lastName = _.defaultTo(params.lastName, '');
    this.joinDate = DateTime.fromISO(
      _.defaultTo(params.joinDate, '2000-01-01'),
      { zone: 'utc' },
    );
    this.clinicRoleName = _.defaultTo(params.clinicRoleName, '');
    this.clinicRoleDisplayName = _.defaultTo(params.clinicRoleDisplayName, '');
    this.clinicRoleAbbreviation = _.defaultTo(
      params.clinicRoleAbbreviation,
      '',
    );
    this.isPrimaryInClinicRole = _.defaultTo(
      params.isPrimaryInClinicRole,
      false,
    );
    this.isClinicRole = _.defaultTo(params.isClinicRole, false);
    this.isVetAssistant = _.defaultTo(params.isVetAssistant, false);
    this.isDVM = _.defaultTo(params.isDVM, false);
    this.anonymizedFirstLastOnly =
      (this.isDVM ? 'Dr. ' : '') +
      this.firstName +
      ' ' +
      (this.lastName ? this.lastName.substring(0, 1) + '.' : '');
  }
}
